// extracted by mini-css-extract-plugin
export default {"container":"style_container__59eGp","children":"style_children__iZTpz","title":"style_title__wFg0S","divider":"style_divider__kwuAd","formFooter":"style_formFooter__e305P"};